export let forEach = (array, callback, scope) => {
    for (let i = 0; i < array.length; i++) {
        callback.call(scope, i, array[i]);
    }
};

export default forEach;
